/* --------------------------------------------------------------------------------------
   common.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class commonService {
  /*@ngInject*/
  constructor (appSettings, persistService, deviceInfoService, $translate, $timeout, $window) {
    this.appSettings = appSettings
    this.persistService = persistService
    this.deviceInfoService = deviceInfoService
    this.$translate = $translate
    this.$timeout = $timeout
    this.$window = $window
  }
  setColoredBackground () {
    const body = angular.element('#ui-wrapper')
    if (!body.hasClass(this.appSettings.primaryColor))
        body.addClass('xrx-background ' + this.appSettings.primaryColor)
  }
  setDefaultBackground () {
    angular.element('#ui-wrapper').removeClass('xrx-background ' + this.appSettings.primaryColor)
  }
  validateDate(date) {
    if (date == null || date.length < 1)
      return false
    console.log(date)
    return true
  }
  updateView() {
    return this.$timeout(() => 1 == 1)
  }
  async handleError(error) {
    const result = await this.$translate('TRY_AGAIN')

    return result
    /*try {
      const refnum = await this.dataService.postLog(error)
      return await this.$translate(['GENERIC_ERROR','REFERENCE_NUMBER'], {ref: refnum})
    } catch (e) {
      return await this.$translate('TRY_AGAIN')
    }*/
  }
  getNewGuid() {
  //// TEMP: when scan profile available this will not be needed
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  }
  getScreenSize() {
    return (angular.element(this.$window).width() > 801)? 10 : 7
  }
  getDeviceLocation() {
    const location = this.persistService.getObject('location')
    const defaultLocation = {code:'us',name:'United States'}
    if (!location)
      return defaultLocation
    return location
  }
  updateLocation(location) {
    if (location && location.code && location.name) {
      this.persistService.setObject('location', location)
    }
  }
  getCurrentSlot() {
    const host = this.$window.location.host
    console.log('host is: ' + host)

    if (host.includes('localhost'))
      return 'local'
    if (host.includes('-test'))
      return 'test'
    if (host.includes('-staging'))
      return 'staging'

    return null
  }
  async isAltalink() {
    const deviceInfo = await this.deviceInfoService.get()
    return deviceInfo.model.toLowerCase().includes('alta')
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/common.service.js